import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import "./index.scss";

const AgencyBillMaster = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [formData, setFormData] = useState({
    configCode: "",
    configName: "",
    isActive: true,
    billFrequency: "Monthly",
    billDay: 1,
    paymentTerms: 30,
    gracePeriod: 5,
    commissionCalc: "Product-Based",
    defaultCommRate: 10.00,
    includeServiceTax: true,
    serviceTaxRate: 18.00
  });

  const [agencies, setAgencies] = useState([
    { agencyCode: "AG001", agencyName: "Premier Insurance Agency", agencyType: "Direct", billMethod: "Agency Bill", commissionRate: 12.5, creditLimit: 100000, paymentTerms: 30, active: true },
    { agencyCode: "AG002", agencyName: "Global Brokers Ltd", agencyType: "Broker", billMethod: "Direct Bill", commissionRate: 15.0, creditLimit: 150000, paymentTerms: 45, active: true },
    { agencyCode: "AG003", agencyName: "Corporate Solutions", agencyType: "Corporate", billMethod: "Account Current", commissionRate: 10.0, creditLimit: 200000, paymentTerms: 60, active: true },
    { agencyCode: "AG004", agencyName: "ABC Bank Insurance", agencyType: "Bancassurance", billMethod: "Agency Bill", commissionRate: 8.5, creditLimit: 250000, paymentTerms: 30, active: true }
  ]);

  const agencyTypeOptions = [
    { label: "Direct", value: "Direct" },
    { label: "Broker", value: "Broker" },
    { label: "Corporate", value: "Corporate" },
    { label: "Bancassurance", value: "Bancassurance" }
  ];

  const billMethodOptions = [
    { label: "Agency Bill", value: "Agency Bill" },
    { label: "Direct Bill", value: "Direct Bill" },
    { label: "Account Current", value: "Account Current" }
  ];

  return (
    <div className="agency-bill-master">
      <Card title="Agency Bill Processing Master">
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
          <TabPanel header="Configuration">
            <div className="form-section">
              <h3>Agency Bill Settings</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                  <label>Config Code *</label>
                  <InputText value={formData.configCode} onChange={(e) => setFormData({ ...formData, configCode: e.target.value })} placeholder="ABL-001" />
                </div>
                <div className="p-field p-col-12 p-md-4">
                  <label>Config Name *</label>
                  <InputText value={formData.configName} onChange={(e) => setFormData({ ...formData, configName: e.target.value })} />
                </div>
                <div className="p-field p-col-12 p-md-4">
                  <label>Active</label>
                  <div className="checkbox-wrapper">
                    <Checkbox checked={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.checked })} />
                    <label className="checkbox-label">Active</label>
                  </div>
                </div>
              </div>

              <h3>Processing Rules</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-6">
                  <label>Bill Generation Frequency</label>
                  <Dropdown value={formData.billFrequency} options={[
                    { label: "Monthly", value: "Monthly" },
                    { label: "Quarterly", value: "Quarterly" },
                    { label: "Semi-Annual", value: "Semi-Annual" },
                    { label: "Annual", value: "Annual" },
                    { label: "On-Demand", value: "On-Demand" }
                  ]} onChange={(e) => setFormData({ ...formData, billFrequency: e.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Bill Generation Day</label>
                  <InputNumber value={formData.billDay} onValueChange={(e) => setFormData({ ...formData, billDay: e.value })} min={1} max={31} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Payment Terms (Days)</label>
                  <InputNumber value={formData.paymentTerms} onValueChange={(e) => setFormData({ ...formData, paymentTerms: e.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Grace Period (Days)</label>
                  <InputNumber value={formData.gracePeriod} onValueChange={(e) => setFormData({ ...formData, gracePeriod: e.value })} />
                </div>
              </div>

              <h3>Commission Settings</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-6">
                  <label>Commission Calculation</label>
                  <Dropdown value={formData.commissionCalc} options={[
                    { label: "Flat Rate", value: "Flat Rate" },
                    { label: "Tiered", value: "Tiered" },
                    { label: "Product-Based", value: "Product-Based" },
                    { label: "Custom Formula", value: "Custom Formula" }
                  ]} onChange={(e) => setFormData({ ...formData, commissionCalc: e.value })} />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Default Commission Rate (%)</label>
                  <InputNumber value={formData.defaultCommRate} onValueChange={(e) => setFormData({ ...formData, defaultCommRate: e.value })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} suffix="%" />
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Include Service Tax</label>
                  <div className="checkbox-wrapper">
                    <Checkbox checked={formData.includeServiceTax} onChange={(e) => setFormData({ ...formData, includeServiceTax: e.checked })} />
                    <label className="checkbox-label">Include</label>
                  </div>
                </div>
                {formData.includeServiceTax && (
                  <div className="p-field p-col-12 p-md-6">
                    <label>Service Tax Rate (%)</label>
                    <InputNumber value={formData.serviceTaxRate} onValueChange={(e) => setFormData({ ...formData, serviceTaxRate: e.value })} mode="decimal" minFractionDigits={2} maxFractionDigits={2} suffix="%" />
                  </div>
                )}
              </div>
            </div>
          </TabPanel>

          <TabPanel header="Agency Setup">
            <div className="toolbar mb-3">
              <Button label="Add Agency" icon="pi pi-plus" className="mr-2" />
              <Button label="Import" icon="pi pi-upload" className="p-button-secondary" />
            </div>
            <DataTable value={agencies} editMode="cell" stripedRows>
              <Column field="agencyCode" header="Agency Code" editor={(props) =>
                <InputText value={props.value} onChange={(e) => props.editorCallback(e.target.value)} />
              } />
              <Column field="agencyName" header="Agency Name" editor={(props) =>
                <InputText value={props.value} onChange={(e) => props.editorCallback(e.target.value)} />
              } />
              <Column field="agencyType" header="Type" editor={(props) =>
                <Dropdown value={props.value} options={agencyTypeOptions} onChange={(e) => props.editorCallback(e.value)} />
              } />
              <Column field="billMethod" header="Bill Method" editor={(props) =>
                <Dropdown value={props.value} options={billMethodOptions} onChange={(e) => props.editorCallback(e.value)} />
              } />
              <Column field="commissionRate" header="Comm Rate (%)" editor={(props) =>
                <InputNumber value={props.value} onValueChange={(e) => props.editorCallback(e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={2} />
              } />
              <Column field="creditLimit" header="Credit Limit" body={(data) => `$${data.creditLimit.toLocaleString()}`} editor={(props) =>
                <InputNumber value={props.value} onValueChange={(e) => props.editorCallback(e.value)} mode="currency" currency="USD" />
              } />
              <Column field="paymentTerms" header="Payment Terms" editor={(props) =>
                <InputNumber value={props.value} onValueChange={(e) => props.editorCallback(e.value)} />
              } />
              <Column field="active" header="Active" body={(rowData) => <Checkbox checked={rowData.active} disabled />} editor={(props) =>
                <Checkbox checked={props.value} onChange={(e) => props.editorCallback(e.checked)} />
              } />
              <Column header="" body={() => (
                <div className="action-buttons">
                  <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" />
                  <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" />
                </div>
              )} style={{ width: '100px' }} />
            </DataTable>
          </TabPanel>

          <TabPanel header="GL Accounts">
            <div className="form-section">
              <h3>Agency Bill GL Configuration</h3>
              <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-6">
                  <label>Agency Receivable Account *</label>
                  <div className="p-inputgroup">
                    <InputText placeholder="Enter GL Account" />
                    <Button icon="pi pi-search" />
                  </div>
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Commission Payable Account *</label>
                  <div className="p-inputgroup">
                    <InputText placeholder="Enter GL Account" />
                    <Button icon="pi pi-search" />
                  </div>
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Premium Account *</label>
                  <div className="p-inputgroup">
                    <InputText placeholder="Enter GL Account" />
                    <Button icon="pi pi-search" />
                  </div>
                </div>
                <div className="p-field p-col-12 p-md-6">
                  <label>Service Tax Account *</label>
                  <div className="p-inputgroup">
                    <InputText placeholder="Enter GL Account" />
                    <Button icon="pi pi-search" />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
        </TabView>

        <div className="button-group mt-4">
          <Button label="Save" icon="pi pi-check" className="p-button-success" />
          <Button label="Cancel" icon="pi pi-times" className="p-button-secondary ml-2" />
        </div>
      </Card>
    </div>
  );
};

export default AgencyBillMaster;
